import { createContext } from 'react'

export const CalendarGridContext = createContext({
  DayPopoverActions: null,
  ItemCard: null,
  ItemRow: null,
  ItemStatus: null,
  ItemTag: null,
})
